import { AppState } from '../../../../redux/reducers';
import { FileUpload, FileUploadRequest } from '../../../../models/Entities/Contracts/FileUpload';

//stores 
import * as FilesUploadStore from '../../../../redux/middleware/FileUploadMiddleware'

//#region Props

export interface IProps {
  isOpen: boolean;
  onDismiss: () => void;
  ContractId: number;
}

interface ConnectedProps {
  FileUploadResult?: {
    succeeded: boolean;
    message: string;
  };
  EditingFileUpload?: {
    id: number;
    name?: string;
    description?: string;
    tags?: string[];
    metadata?: Record<string, unknown>;
  };
}

interface DispatchProps {
  CreateFileUpload: (request: FileUploadRequest) => Promise<void>;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState) => ({
  FileUploadResult: state.FileUpload?.FileUploadResult,
  EditingFileUpload: state.FileUpload?.EditingFileUpload
});

export const mapDispatchToProps = (dispatch: any, ownProps: IProps) => ({
  CreateFileUpload: (request: FileUploadRequest): Promise<void> => {
    // Convert FileUploadRequest to FileUpload
    const fileUpload: FileUpload = {
      id: 0, // This will be assigned by the server
      fileName: request.file.name,
      fileSize: request.file.size,
      contentType: request.file.type,
      uploadDate: new Date(),
      uploadedBy: '', // Will be filled by server
      entityType: request.entityType,
      entityId: request.entityId,
      filePath: '', // Will be filled by server
      tags: request.tags,
      metadata: request.metadata,
      isActive: true,
      File: request.file,
      contractId: ownProps.ContractId,
      fileId: '',
      fileType: '',
      fileExtension: ''
    };

    return dispatch(FilesUploadStore.actionCreators.CreateFileUpload(fileUpload, request.onUploadProgress));
  }
});

//#endregion Props